// info-2.twig

import React from 'react'
import {Content, contextualSpaces, Headline} from '@miro-site/components_utils'
import {Box, Container, Section} from '@miro-site/core'

const FrameWrapperStyles = {
  marginTop: [28, 40],
  height: [280, 580],
  width: '100%',
}

interface OneColumnEmbedProps {
  headline: React.ComponentProps<typeof Headline>
  content?: React.ComponentProps<typeof Content>
  embed_id: string
}

const OneColumnEmbed: React.FC<OneColumnEmbedProps> = ({headline, content, embed_id}) => {
  return (
    <Section data-place="Embed Section">
      <Container>
        {headline?.text && (
          <Headline {...headline} size="mid" tag="h2" align={headline.align || 'left'} />
        )}
        {content && (
          <Content
            {...content}
            textProps={{$styles: {marginTop: contextualSpaces.textSpaces.afterHeadline.medium}}}
          />
        )}
        {embed_id && (
          <Box $styles={FrameWrapperStyles}>
            <iframe
              src={`https://miro.com/app/embed/${embed_id}/?autoplay=yep`}
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              title={typeof headline.text === 'string' ? headline.text : embed_id}
            ></iframe>
          </Box>
        )}
      </Container>
    </Section>
  )
}

export default OneColumnEmbed
